import moment from 'moment'
import { Flex, Text } from "@chakra-ui/react";
import SubHeading from "../Text/SubHeading";
import SmallContainer from "../Container/SmallContainer";

const Slots = ({ dailyData, selectedSlot, setSelectedSlot, selectedDate }) => {
  return (
    <SmallContainer marginTop={"10px"}  h={"540"} overflowY={"auto"}>
      {!selectedDate ? (
        <SmallContainer marginTop="20px">
          <SubHeading subHeadingLabel="*Please select a Date"></SubHeading>
        </SmallContainer>
      ) : (
        <>
          <SmallContainer marginBottom={"20px"} alignItems={"center"}>
            {dailyData ? (
              dailyData["availableSlots"]?.sort((a, b) => {
                const aStart = moment(a.slotTime.split("-")[0], "HH:mm");
                const bStart = moment(b.slotTime.split("-")[0], "HH:mm");
                return aStart - bStart;
              })
              .map(
                (slot, i) =>
                  slot.closed !== true &&
                  dailyData["agentsPerSlot"]?.[slot?.timeSlotId] >
                    dailyData["bookingsPerSlot"]?.[slot?.timeSlotId] && (
                    <SubHeading
                      display={"flex"}
                      justifyContent="center"
                      alignItems={"center"}
                      key={i}
                      backgroundColor={
                        selectedSlot?.slotTime === slot.slotTime
                          ? "#0E3665"
                          : "#ECEFF9"
                      }
                      color={
                        selectedSlot?.slotTime === slot.slotTime
                          ? "#FFFFFF"
                          : "#0E3665"
                      }
                      textColor={
                        selectedSlot?.slotTime === slot.slotTime
                          ? "#FFFFFF"
                          : "#0E3665"
                      }
                      width={"70%"}
                      borderRadius={"100px"}
                      height={"38px"}
                      _hover={{
                        color: "#FFFFFF",
                        backgroundColor: "#0E3665",
                        cursor: "pointer",
                      }}
                      mt={"4"}
                      onClick={() => setSelectedSlot(slot)}
                      subHeadingLabel={slot.slotTime}
                    />
                  )
              )
            ) : (
              <Text>No Slot Available</Text>
            )}
          </SmallContainer>
        </>
      )}
    </SmallContainer>
  );
};

export default Slots;
